import React, { useState, useMemo, useEffect, useCallback } from 'react';
import { Link } from 'react-router-dom';
import { useNavigate } from 'react-router-dom';
import LS from '../../styles/layoutStyled';
import CS from '../../styles/componentStyled';
import styled from 'styled-components';
import { useSetRecoilState, useRecoilValue, useRecoilState } from 'recoil';
import {
  blankDefaultMsgRecoil,
  errorMsgRecoil,
  confirmMsgRecoil,
} from '../../atom/ModalAtom';
import CntWrap from '../../component/admin/CntWrap';
import SearchOptionWrap from '../../component/SearchOptionWrap';
import InputTitleWrap from '../../component/InputTitleWrap';
import Input from '../../component/Input';
import TableOptionWrap from '../../component/TableOptionWrap';
import Select from '../../component/Select';
import { SizeList } from '../../model/common.dto';
import Table from '../../component/Table';
import { adminAPI } from '../../api/axiosIndex';
import {
  UserListDto,
  UserListResDto,
  UserListSearchDto,
} from '../../model/user.dto';
import Pagenation from '../../component/Pagenation';

const UserList = () => {
  const blankMsg = useRecoilValue(blankDefaultMsgRecoil);
  const setError = useSetRecoilState(errorMsgRecoil);
  const setConfirm = useSetRecoilState(confirmMsgRecoil);

  const navigate = useNavigate();

  const [passid, setPassid] = useState('');
  const [phone, setPhone] = useState('');
  const [userNumber, setUserNumber] = useState('');
  const [otherText, setOtherText] = useState('');
  const [nickname, setNickname] = useState('');
  const [page, setPage] = useState('1');
  const [size, setSize] = useState('10');
  const [userList, setUserList] = useState<UserListDto[]>([]);
  const [total, setTotal] = useState('');

  const sort = 'createdAt';
  const order = 'desc';

  const handleUserList = async (resetType?: string) => {
    const dto: UserListSearchDto = {
      passid,
      phone,
      userNumber,
      otherText,
      nickname,
      page: Number(page),
      size: Number(size),
      sort,
      order,
    };

    if (resetType === 'pageReset') {
      dto.page = 1;
      setPage('1');
    }

    if (resetType === 'allReset') {
      dto.passid = '';
      dto.phone = '';
      dto.userNumber = '';
      dto.otherText = '';
      dto.nickname = '';
      dto.page = 1;
      dto.size = 10;
      setPassid('');
      setPhone('');
      setUserNumber('');
      setOtherText('');
      setNickname('');
      setPage('1');
      setSize('10');
    }

    const { data } = await adminAPI.getUserList(dto);

    setTotal(String(data.total));
    setUserList(data.results);
  };

  const handleSearch = () => {
    handleUserList('pageReset');
  };

  const handleReset = () => {
    handleUserList('allReset');
  };

  const handlePageChange = (value: number) => {
    setPage(String(value));
  };

  useEffect(() => {
    handleUserList();
  }, [page]);

  useEffect(() => {
    handleUserList('pageReset');
  }, [size]);

  return (
    <>
      <CntWrap title="회원 목록">
        <SearchOptionWrap onSearch={handleSearch} onReset={handleReset}>
          <InputTitleWrap title="아이디">
            <Input
              placeholder="아이디 입력"
              type="text"
              theme="type1"
              width="100%"
              value={passid}
              setValue={setPassid}
            />
          </InputTitleWrap>
          <InputTitleWrap title="핸드폰 번호">
            <Input
              placeholder="핸드폰 번호 입력"
              type="text"
              theme="type1"
              width="100%"
              value={phone}
              setValue={setPhone}
            />
          </InputTitleWrap>
          <InputTitleWrap title="사번">
            <Input
              placeholder="사번 입력"
              type="text"
              theme="type1"
              width="100%"
              value={userNumber}
              setValue={setUserNumber}
            />
          </InputTitleWrap>
          <InputTitleWrap title="기타사항">
            <Input
              placeholder="기타사항 입력"
              type="text"
              theme="type1"
              width="100%"
              value={otherText}
              setValue={setOtherText}
            />
          </InputTitleWrap>
          <InputTitleWrap title="닉네임">
            <Input
              placeholder="닉네임 입력"
              type="text"
              theme="type1"
              width="100%"
              value={nickname}
              setValue={setNickname}
            />
          </InputTitleWrap>
        </SearchOptionWrap>
        <TableOptionWrap postNum={String(total)}>
          <Select
            theme="type1"
            width="150px"
            value={size}
            setValue={setSize}
            options={SizeList}
          />
        </TableOptionWrap>
        <Table
          theme="type1"
          thList={['No', '아이디', '핸드폰 번호', '사번', '기타사항', '닉네임']}
        >
          {userList.map((user, index) => (
            <tr key={user.id}>
              <td>{index + 1 + (Number(page) - 1) * Number(size)}</td>
              <td>{user.passid}</td>
              <td>{user.phone}</td>
              <td>{user.userNumber}</td>
              <td>{user.otherText}</td>
              <td>{user.nickname}</td>
            </tr>
          ))}
        </Table>
        <Pagenation
          listAllLength={Number(total)}
          listLimit={Number(size)}
          onCurrentPageChange={handlePageChange}
        />
      </CntWrap>
    </>
  );
};

export default UserList;
